function renderSplide(customSelector) {

	let defaultOptions = {
		arrows: true,
		autoplay: true,
		drag: true,
		pagination: true,
		focus: 'center',
		type: "loop",
		trimSpace: true,
		perPage: 1
	};

	let selector = customSelector || ".splide--caramella";
	if (typeof Splide !== 'undefined') {
		jQuery(selector).each(function (i, slider) {
			let $this = jQuery(this); // Current element in the iteration

			if ($this.data('splide-initialized')) return;
			let customOptions = $this.data('options');
			let mergedOptions = Object.assign({}, defaultOptions, customOptions);
			let splideInstance = new Splide(slider, mergedOptions); // Use the DOM element for Splide
			splideInstance.mount();
			$this.data('splide-initialized', true);
		});
	} else {
		console.warn("Splide is not loaded so we are skipping it.");
	}
}

window.caramellaSafeExecute(renderSplide);

//	EXAMPLE:
//	<div class="splide--demo" data-options='{"arrows":false,"autoplay":false,"drag":true,"pagination":true,"focus":"center","type":"loop","trimSpace":true,"perPage":2}'></div>
